<template>
	<div id="footer">
		<div class="mainbox">
			<div class="column">
				<!-- <span class="title">关于三特</span>
				<span class="link" v-for="(item,index) in channels" :key="index">{{item.label}}</span> -->
				<div>
					<div style="font-size: 14px;color: #8D8D8D;">
						<span @click="toAboutUs()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;cursor: pointer;">关于我们</span>
						<span @click="toHehuaCulture()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;padding-left: 10px;cursor: pointer;">和华文化</span>
						<span @click="toBusinessArea()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;padding-left: 10px;cursor: pointer;">业务领域</span>
						<span @click="toProfessional()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;padding-left: 10px;cursor: pointer;">专业人员</span>
						<span @click="toNews()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;padding-left: 10px;cursor: pointer;">资讯动态</span>
						<span @click="toContactUs()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;padding-left: 10px;cursor: pointer;">联系我们</span>
						<span @click="toDisclaimer()" style="padding-right: 10px;border-right: 1px solid #8D8D8D;padding-left: 10px;cursor: pointer;">免责条款</span>
						<span @click="toPrivacyPolicy()" style="padding-right: 10px;padding-left: 10px;cursor: pointer;">隐私政策</span>
					</div>
					<div style="padding-top: 50px;font-size: 14px;color: #8D8D8D;cursor: pointer;" @click="toUrl">Copyright©️2023  上海和华利盛律师事务所  版权所有  沪ICP备17055877号-1</div>
				</div>
			</div>
			<!-- <div class="column">
				<span class="title">友情链接</span>
				<a class="link" href="http://www.sante.com.cn/" target="_blank">武汉三特索道集团股份有限公司</a>
				<a class="link" href="" target="_blank">唐山启晟信息科技有限公司</a>
			</div>
			<div class="column">
				<span class="title">联系我们</span>
				<span class="link">电话：18871961676</span>
				<span class="link">邮箱：Remember520_ZXY@163.com</span>
				<span class="link">地址：武汉东湖新技术开发区关山一路特1号光谷软件园D1栋1楼108室</span>
			</div> -->
			<div class="qrcode">
				<!-- <div class="app">
					<img src="../../assets/fImage/qrcode.jpg">
					<span>APP下载</span>
				</div> -->
				<div class="wechat">
					<img src="../../assets/fImage/qrcode.jpg">
					<span style="font-size:12px" @click="toAdmin()">和华利盛微信公众号</span>
				</div>
			</div>
		</div>
		<!--<div class="tipbox">
			<span>版权所有 © 2021-2030 武汉三特索道科技有限公司</span>
			<span class="block"></span>
			<span>备案号：</span>
			<a class="link" href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2021022516号-1</a>
		</div> -->
	</div>
</template>

<script>
	import {queryByPos,queryIndexByPos} from "../../api/front.js"
	export default {
		name: "Footer",
		data() {
			return {
				channels: [],
			}
		},
		mounted() {
			queryIndexByPos('nav').then(data => {
				this.channels = data.data
			}).catch(error => {
			
			})
		},
		methods:{
			toUrl(){
        window.open('https://beian.miit.gov.cn/')
			},
			toAboutUs(){
				this.$router.push(
					{
						path:'/aboutUs'
					}
				);
			},
			toHehuaCulture(){
				this.$router.push(
					{
						path:'/hehuaCulture'
					}
				);
			},
			toBusinessArea(){
				this.$router.push(
					{
						path:'/businessArea'
					}
				);
			},
			toProfessional(){
				this.$router.push(
					{
						path:'/professional'
					}
				);
			},
			toNews(){
				this.$router.push(
					{
						path:'/news'
					}
				);
			},
			toContactUs(){
				this.$router.push(
					{
						path:'/contactUs'
					}
				);
			},
			toDisclaimer(){
				this.$router.push(
					{
						path:'/disclaimer'
					}
				);
			},
			toPrivacyPolicy(){
				this.$router.push(
					{
						path:'/privacyPolicy'
					}
				);
			},
			
			toAdmin(){
				this.$router.push(
					{
						path:'/adminLogin',
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	a{
		color: #FFFFFF;
		text-decoration: none;
	}
	a:hover {  
		color : #1a86ff ; 
	}
	#footer {
		height: 250px;
		width: 100%;
		background-color: #202020;
		color: #FFFFFF;
		font-family: Adobe Heiti Std R;
		.mainbox{
			border-bottom: 2px solid #202020;
			flex-direction: row;
			justify-content: space-between;
			.column{
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				width: 70%;
				float: left;
				padding-top: 50px;
				padding-left: 18%;
				.title{
					margin-bottom: 10px;
					font-size: 18px;
					line-height: 27px;
				}
				.link{
					margin-bottom: 5px;
				}
			}
			.qrcode{
				width: 120px;
				position: absolute;
				left: 75.5%;
				padding-top: 50px;
				img{
					width: 100px;
					height: 100px;
					margin: 0px 0 0 10px;
				}
				span{
					display: inline-block;
					width: 120px;
					text-align: center;
				};
			}
		}
		.tipbox{
			padding: 12px 15% 16px 15%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			.block{
				display: inline-block;
				width: 200px;
			}
			span{
				display: inline-block;
			};
		}
	}
</style>
